<template>
  <Transition name="slide-down">
    <div v-if="isOffline" class="offline-indicator" dir="rtl">
      <span class="offline-icon">📡</span>
      <span>اتصال اینترنت برقرار نیست. در حالت آفلاین هستید.</span>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'OfflineIndicator',
  data () {
    return {
      isOffline: !navigator.onLine
    }
  },
  mounted () {
    window.addEventListener('online', this.setOnline)
    window.addEventListener('offline', this.setOffline)
    document.addEventListener('sw-offline', this.setOffline)
  },
  beforeUnmount () {
    window.removeEventListener('online', this.setOnline)
    window.removeEventListener('offline', this.setOffline)
    document.removeEventListener('sw-offline', this.setOffline)
  },
  methods: {
    setOnline () {
      this.isOffline = false
    },
    setOffline () {
      this.isOffline = true
    }
  }
}
</script>

<style scoped>
.offline-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9998;
  background: #d24005;
  color: #fff;
  padding: 10px 20px;
  text-align: center;
  font-family: 'IRANSansXFaNum-Light', sans-serif;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.offline-icon {
  font-size: 18px;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
}
</style>
